<template>
  <v-select
    :loading="carregando"
    :items="escolaridades"
    item-text="descricao"
    item-value="codigo"
    no-data-text="Nenhuma escolaridade encontrada"
    v-model="escolaridadeModel"    
  >
  </v-select>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("candidaturainterna", [
      "escolaridades",
      "escolaridadeSelecionada",
    ]),
    escolaridadeModel: {
      get: function () {
        return this.escolaridadeSelecionada;
      },
      set: function (value) {
        this.setSelecionaEscolaridade(value);
      },
    },
  },
  data: () => ({
    carregando: false,
  }),
  methods: {
    ...mapMutations("candidaturainterna", [
      "setEscolaridades",
      "setSelecionaEscolaridade",
    ]),
    async getEscolaridades() {
      this.carregando = true;
      this.setEscolaridades([]);
      await axios
        .get("/colaborador/candidatura-interna?funcao=ESCOLARIDADES")
        .then((res) => {
          if (res.data.success) {
            this.setEscolaridades(res.data.data);
          }
        });
      this.carregando = false;
    },
  },
  async created() {
    await this.getEscolaridades();
  },
};
</script>

<style>
</style>